var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolyBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421 296L342.5 289L449 376Z",
    fill: "#242424",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 289L318.5 425L449 376Z",
    fill: "#262626",
    stroke: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 425L359.5 479L449 376Z",
    fill: "#242424",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 296L302.5 209L342.5 289Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 289L198 360L318.5 425Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 273L198 360L342.5 289Z",
    fill: "#262626",
    stroke: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 425L238 481L359.5 479Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 360L238 481L318.5 425Z",
    fill: "#242424",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.5 326L484 195L421 296Z",
    fill: "#202020",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 296L484 195L302.5 209Z",
    fill: "#242424",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 600L467 532L359.5 479Z",
    fill: "#242424",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.5 479L467 532L449 376Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 376L576.5 326L421 296Z",
    fill: "#202020",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5 209L222 228L342.5 289Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.5 433L576.5 326L449 376Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 228L187 273L342.5 289Z",
    fill: "#202020",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 532L591.5 433L449 376Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.5 326L537.5 177L484 195Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 195L307.5 104L302.5 209Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258 600L361.5 600L359.5 479Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 532L590.5 481L591.5 433Z",
    fill: "#202020",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 508L590.5 481L586.5 600Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5 600L430 600L359.5 479Z",
    fill: "#242424",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 60L307.5 104L484 195Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5 209L307.5 104L222 228Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 299L105.5 361L187 273Z",
    fill: "#262626",
    stroke: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.5 433L641 325L576.5 326Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.5 326L675 231L537.5 177Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 366L641 325L591.5 433Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 481L258 600L359.5 479Z",
    fill: "#262626",
    stroke: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 527L258 600L238 481Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 273L105.5 361L198 360Z",
    fill: "#202020",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 360L105.5 361L238 481Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 299L187 273L76.5 214Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 214L187 273L222 228Z",
    fill: "#262626",
    stroke: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 600L590.5 481L467 532Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.5 481L636 508L591.5 433Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 231L569.5 125L537.5 177Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.5 177L448 60L484 195Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.5 125L448 60L537.5 177Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 508L685 366L591.5 433Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 325L675 231L576.5 326Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 392L111.5 527L105.5 361Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 361L111.5 527L238 481Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 600L586.5 600L467 532Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 366L675 231L641 325Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 68L76.5 214L222 228Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.5 0L213 63L307.5 104Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5 104L213 63L222 228Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 600L111.5 600L111.5 527Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 527L111.5 600L258 600Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.5 0L428 0L448 60Z",
    fill: "#262626",
    stroke: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 60L322.5 0L307.5 104Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 0L322.5 0L448 60Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 299L0 392L105.5 361Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 287L0 392L82.5 299Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 237L82.5 299L76.5 214Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 237L0 287L82.5 299Z",
    fill: "#242424",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.5 0L208 0L213 63Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 63L101.5 68L222 228Z",
    fill: "#202020",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 108L0 237L76.5 214Z",
    fill: "#202020",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.5 125L545.5 0L448 60Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 61L545.5 0L569.5 125Z",
    fill: "#242424",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 0L101.5 68L213 63Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 231L653 61L569.5 125Z",
    fill: "#202020",
    stroke: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 392L0 510L111.5 527Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 508L797.5 460L685 366Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685 366L812.5 268L675 231Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 600L712 600L636 508Z",
    fill: "#242424",
    stroke: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712 600L797.5 460L636 508Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 231L785.5 179L653 61Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.5 460L816.5 409L685 366Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.5 409L812.5 268L685 366Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.5 268L785.5 179L675 231Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 510L0 600L111.5 527Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 68L0 108L76.5 214Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 108L101.5 68Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 0L80.5 0L101.5 68Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.5 105L689 0L653 61Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 61L689 0L545.5 0Z",
    fill: "#262626",
    stroke: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 77L789.5 105L785.5 179Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.5 179L789.5 105L653 61Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 496L900 381L816.5 409Z",
    fill: "#171717",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712 600L814.5 600L797.5 460Z",
    fill: "#212121",
    stroke: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 0L0 0L101.5 68Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 496L816.5 409L797.5 460Z",
    fill: "#1a1a1a",
    stroke: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.5 409L900 381L812.5 268Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.5 268L900 215L785.5 179Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 381L900 269L812.5 268Z",
    fill: "#232323",
    stroke: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.5 600L900 496L797.5 460Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 269L900 215L812.5 268Z",
    fill: "#1b1b1b",
    stroke: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.5 105L795.5 0L689 0Z",
    fill: "#181818",
    stroke: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 77L795.5 0L789.5 105Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.5 600L900 600L900 496Z",
    fill: "#1d1d1d",
    stroke: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 215L900 77L785.5 179Z",
    fill: "#1e1e1e",
    stroke: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 77L900 0L795.5 0Z",
    fill: "#262626",
    stroke: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyBg);
export default __webpack_public_path__ + "static/media/poly_bg.a9dfb60a1086c6e5c3bbaf53a8e6b5f3.svg";
export { ForwardRef as ReactComponent };